module.exports = __webpack_public_path__ + "img/2560x1480-3.3e247121.gif";